const getCountProjectValue = (countProjects, totalProjects, arrayToCount) => {
  return countProjects ? totalProjects : arrayToCount.length;
};

export { getCountProjectValue };
